module.exports = {
    expired_1: "Ссылка истекла",
    limit_time: "Предложение на ограниченное время для ",
    participate: "Примите участие в акции с отзывами прямо сейчас, чтобы получить эксклюзивную награду!",
    exclusive: "Эксклюзивный",
    reward: "Награда",
    token: "Токены",
    vip: "Дней VIP",
    after_completing: "После завершения отзыва и проверки скриншота вы получите",
    step_1: "<strong style='color: #000000'>Нажмите на кнопку ниже</strong>, чтобы перейти в магазин приложений и <strong style='color: #000000'>оставить отзыв на 5 звезд.</strong>",
    step_2: "После завершения отзыва, пожалуйста, <strong style='color: #000000'>сделайте скриншот</strong> содержания вашего отзыва.",
    step_3: "<strong style='color: #000000'>Загрузите скриншот</strong> ниже и отправьте ваш внутриигровой ID, чтобы получить награду.",
    click_to: "1. Нажмите, чтобы перейти в ",
    upload: "2. Загрузить скриншот отзыва",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "Перейти в ",
    example: "Пример скриншота",
    upload_screenshot: "Загрузить скриншот",
    claim: "Получить награду",
    verification_inprogress: "Спасибо за вашу загрузку. Ваш скриншот проверяется как можно быстрее. Пожалуйста, будьте терпеливы.",
    verification_success: "Поздравляем! <br/><br/> Вы успешно получили свою награду. Награда будет зачислена на ваш счет <strong>в течение 24 часов.</strong> Пожалуйста, следите за обновлениями. <br/><br/> Если у вас есть какие-либо вопросы, не стесняйтесь обращаться в службу поддержки.",
    verification_failed: "Скриншот отзыва должен соответствовать следующим условиям: <br/><br/> <div style='margin-left: 6px'> 1.Оценка должна быть 5 звезд, и содержание должно быть положительным. <br/><br/> 2.Отзыв должен быть оставлен в <strong> Apple App Store или Google Play Store. </strong> <br/><br/> 3.Скриншот должен полностью отображать содержание отзыва, включая <strong> аватар, имя пользователя и текст отзыва. <strong></div>",
    reupload: "Повторная загрузка",
}